export default "__VITE_ASSET__eepYotS6__"